import * as React from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '../../lib/utils'

/**
 * Lightweight styled native <select>. Native dropdowns are accessible,
 * keyboard-friendly and fast — ideal for the dense mapping/rules UI.
 */
// The caller's sizing classes (h-*, w-*, min-w-*) go on the WRAPPER, not the
// inner <select>: a percentage width like `w-1/3` resolves against the wrapper,
// so if the width sat on the select while the wrapper was shrink-to-fit it would
// collapse (and clip its text to a single char). The select then fills the
// wrapper. No fixed vertical padding — it would clip the text at small heights
// (e.g. h-8); the height centres the value instead.
const Select = React.forwardRef(({ className, children, ...props }, ref) => (
  <div className={cn('relative h-10', className)}>
    <select
      ref={ref}
      className="flex h-full w-full appearance-none rounded-md border border-input bg-background px-3 pr-8 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      {...props}
    >
      {children}
    </select>
    <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
  </div>
))
Select.displayName = 'Select'

export { Select }
